import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { ChildScores } from '@yandex-int/k-common/typings';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';

import { getClessonIdFromProps, getStudentIdFromProps } from 'utils/selectors/selectors';

import { Certificates, CertificatesItem, CertificatesStore } from './typings';

const certificatesStoreSelector = (storeState: CertificatesStore): CertificatesStore => get(storeState, 'certificates');

export const getCertificateList = createSelector(
    [certificatesStoreSelector],
    (store): Record<number, CertificatesItem> => store.certificateList
);

export const getScores = createSelector(
    [certificatesStoreSelector],
    (store): Record<number, ChildScores> => store.scores
);

export const getCertificates = createSelector(
    [getCertificateList, getClessonIdFromProps],
    (state, clessonId): Certificates | null => {
        if (clessonId && state[clessonId]) {
            return state[clessonId].certificates;
        }

        return null;
    }
);

export const hasCertificates = createSelector(getCertificates, (certificates): boolean => !isEmpty(certificates));

export const getStudentCertificate = createSelector(
    [getCertificateList, getClessonIdFromProps, getStudentIdFromProps],
    (state, clessonId, studentId): string | null => {
        if (clessonId && studentId && state[clessonId]) {
            return state[clessonId].certificates[studentId] || null;
        }

        return null;
    }
);

export const getStudentScore = createSelector(
    [getScores, getClessonIdFromProps, getStudentIdFromProps],
    (scores, clessonId, studentId): string | null => {
        if (clessonId && studentId && scores[clessonId]) {
            return scores[clessonId]?.[studentId] || null;
        }

        return null;
    }
);

export const getCertificatesLoadingStatus = createSelector(
    [getCertificateList, getClessonIdFromProps],
    (state, clessonId): LOADING_STATUSES => {
        if (!clessonId) {
            return LOADING_STATUSES.UNSENT;
        }

        return state[clessonId]?.loadingStatus || LOADING_STATUSES.UNSENT;
    }
);

export const hasStudentCertificate = createSelector([getStudentCertificate], (certificate): boolean =>
    Boolean(certificate)
);
